import { Currency } from '@app/src/components/user-management/model/Company';
import { UserInfoLocation } from '@app/src/components/user-management/model/Location';

export enum UserPermissions {
  access_all_tenant_entities = 'am-a-a-te',

  usermanagement_view_company_all = 'um-v-c-a',
  usermanagement_view_company_tenant = 'um-v-c-te',
  usermanagement_view_company_own = 'um-v-c-o',
  usermanagement_create_company_tenant = 'um-c-c-te',
  usermanagement_update_company_all = 'um-u-c-a',
  usermanagement_update_company_tenant = 'um-u-c-te',
  usermanagement_update_company_company = 'um-u-c-c',
  usermanagement_update_company_own = 'um-u-c-o',
  usermanagement_delete_company_tenant = 'um-d-c-te',
  usermanagement_delete_company_own = 'um-d-c-o',
  usermanagement_view_tenant_tab = 'um-v-te-t',
  usermanagement_view_settings_tab = 'um-v-s-t',

  usermanagement_view_user_all = 'um-v-u-a',
  usermanagement_view_user_tenant = 'um-v-u-te',
  usermanagement_view_user_company = 'um-v-u-c',
  usermanagement_view_user_own = 'um-v-u-o',
  usermanagement_view_user_tab = 'um-v-u-t',
  usermanagement_create_user_all = 'um-c-u-a',
  usermanagement_create_user_tenant = 'um-c-u-te',
  usermanagement_create_user_company = 'um-c-u-c',
  usermanagement_update_user_all = 'um-u-u-a',
  usermanagement_update_user_tenant = 'um-u-u-te',
  usermanagement_update_user_company = 'um-u-u-c',
  usermanagement_delete_user_all = 'um-d-u-a',
  usermanagement_delete_user_tenant = 'um-d-u-te',
  usermanagement_delete_user_company = 'um-d-u-c',
  usermanagement_update_user_own = 'um-u-u-o',

  usermanagement_update_user_retention_policy_company = 'um-u-urts-c',

  usermanagement_view_session_company = 'um-v-s-c',
  usermanagement_terminate_session_company = 'um-t-s-c',

  usermanagement_view_license_all = 'um-v-l-a',
  usermanagement_view_license_company = 'um-v-l-c',
  usermanagement_create_license_all = 'um-c-l-a',
  usermanagement_update_license_all = 'um-u-l-a',
  usermanagement_delete_license_all = 'um-d-l-a',
  usermanagement_upload_license_company = 'um-l-l-c',

  usermanagement_view_role_all = 'um-v-r-a',
  usermanagement_view_role_company = 'um-v-r-c',
  usermanagement_view_role_own = 'um-v-r-o',
  usermanagement_view_role_tab = 'um-v-r-t',
  usermanagement_create_role_all = 'um-c-r-a',
  usermanagement_create_role_company = 'um-c-r-c',
  usermanagement_update_role_all = 'um-u-r-a',
  usermanagement_update_role_company = 'um-u-r-c',
  usermanagement_delete_role_all = 'um-d-r-a',
  usermanagement_delete_role_company = 'um-d-r-c',

  usermanagement_view_user_group_tab = 'um-v-ugt-t',
  usermanagement_view_user_group_company = 'um-v-ug-c',
  usermanagement_create_user_group_company = 'um-c-ug-c',
  usermanagement_update_user_group_company = 'um-u-ug-c',
  usermanagement_delete_user_group_company = 'um-d-ug-c',

  usermanagement_view_call_logs_company = 'um-v-cl-c',
  usermanagement_view_call_recordings_company = 'um-v-crc-c',
  usermanagement_update_call_recording_settings_company = 'um-u-crcs-c',
  usermanagement_update_call_storage_settings_company = 'um-u-css-c',
  usermanagement_update_call_retention_settings_company = 'um-u-crts-c',

  // credentials management
  credentialmanagement_view_credential_company = 'cm-v-cr-c',
  credentialmanagement_create_credential_company = 'cm-c-cr-c',
  credentialmanagement_update_credential_company = 'cm-u-cr-c',
  credentialmanagement_delete_credential_company = 'cm-d-cr-c',

  // audit log management
  auditmanagement_view_logs_company = 'al-v-al-c',
  auditmanagement_export_logs_company = 'al-ex-al-c',
  auditmanagement_update_settings_company = 'al-u-s-c',

  // event management
  eventmanagement_view_dashboard_tab = 'em-v-db-t',

  eventmanagement_view_event_all = 'em-v-e-a',
  eventmanagement_view_event_company = 'em-v-e-c',
  eventmanagement_view_event_own = 'em-v-e-o',
  eventmanagement_view_event_restricted = 'em-v-e-r',
  eventmanagement_create_event_all = 'em-c-e-a',
  eventmanagement_create_event_company = 'em-c-e-c',
  eventmanagement_create_event_restricted = 'em-c-e-r',
  eventmanagement_update_event_all = 'em-u-e-a',
  eventmanagement_update_event_company = 'em-u-e-c',
  eventmanagement_update_event_own = 'em-u-e-o',
  eventmanagement_update_event_restricted = 'em-u-e-r',
  eventmanagement_delete_event_all = 'em-d-e-a',
  eventmanagement_delete_event_company = 'em-d-e-c',
  eventmanagement_delete_event_own = 'em-d-e-o',
  eventmanagement_delete_event_restricted = 'em-d-e-r',
  eventmanagement_import_event_company = 'em-im-e-c',
  eventmanagement_view_event_tab = 'em-v-e-t',
  eventmanagement_view_evacuation_list_company = 'em-v-el-c',

  eventmanagement_view_contact_all = 'em-v-c-a',
  eventmanagement_view_contact_company = 'em-v-c-c',
  eventmanagement_update_contact_all = 'em-u-c-a',
  eventmanagement_update_contact_company = 'em-u-c-c',
  eventmanagement_delete_contact_all = 'em-d-c-a',
  eventmanagement_delete_contact_company = 'em-d-c-c',
  eventmanagement_delete_contact_own = 'em-d-c-o',
  eventmanagement_create_contact_all = 'em-c-c-a',
  eventmanagement_create_contact_company = 'em-c-c-c',
  eventmanagement_view_contact_tab = 'em-v-c-t',
  eventmanagement_import_contact_company = 'em-im-c-c',
  eventmanagement_export_contact_company = 'em-ex-c-c',

  eventmanagement_view_visitor_all = 'em-v-v-a',
  eventmanagement_view_visitor_company = 'em-v-v-c',
  eventmanagement_view_visitor_own = 'em-v-v-o',
  eventmanagement_view_visitor_bycompany_restricted = 'em-v-v-bc-r',
  eventmanagement_create_visitor_all = 'em-c-v-a',
  eventmanagement_create_visitor_company = 'em-c-v-c',
  eventmanagement_update_visitor_all = 'em-u-v-a',
  eventmanagement_update_visitor_company = 'em-u-v-c',
  eventmanagement_update_visitor_own = 'em-u-v-o',
  eventmanagement_delete_visitor_all = 'em-d-v-a',
  eventmanagement_delete_visitor_company = 'em-d-v-c',
  eventmanagement_delete_visitor_own = 'em-d-v-o',
  eventmanagement_block_visitor_company = 'em-bl-v-c',
  eventmanagement_checkin_visitor_company = 'em-ch-v-c',
  eventmanagement_import_visitor_company = 'em-im-v-c',
  eventmanagement_export_visitor_company = 'em-ex-v-c',
  eventmanagement_approve_visitor_company = 'em-a-v-c',
  eventmanagement_view_visitor_tab = 'em-v-v-t',

  eventmanagement_view_company_company = 'em-v-vc-c',
  eventmanagement_create_company_company = 'em-c-vc-c',
  eventmanagement_update_company_company = 'em-u-vc-c',
  eventmanagement_delete_company_company = 'em-d-vc-c',
  eventmanagement_delete_company_own = 'em-d-vc-o',
  eventmanagement_import_company_company = 'em-im-vc-c',
  eventmanagement_export_company_company = 'em-ex-vc-c',
  eventmanagement_view_company_tab = 'em-v-vc-t',

  eventmanagement_view_visitlog_company = 'em-v-vl-c',
  eventmanagement_view_visitlog_own = 'em-v-vl-o',
  eventmanagement_view_visitlog_restricted = 'em-v-vl-r',
  eventmanagement_export_visitlog_company = 'em-ex-vl-c',
  eventmanagement_delete_visitlog_company = 'em-d-vl-c',
  eventmanagement_view_visitlog_bycompany_restricted = 'em-v-vl-bc-r',
  eventmanagement_view_visitlog_tab = 'em-v-vl-t',

  eventmanagement_view_onsite_bycompany_restricted = 'em-v-vo-bc-r',
  eventmanagement_view_onsite_tab = 'em-v-vo-t',

  eventmanagement_view_waitlist_tab = 'em-v-wl-t',
  eventmanagement_view_waitlist_company = 'em-v-wl-c',
  eventmanagement_approve_waitlist_company = 'em-a-wl-c',
  eventmanagement_delete_waitlist_company = 'em-d-wl-c',
  eventmanagement_view_waitlist_notification_company = 'em-v-wl-ns-c',

  eventmanagement_view_reception_company = 'em-v-r-c',
  eventmanagement_create_reception_company = 'em-c-r-c',
  eventmanagement_update_reception_company = 'em-u-r-c',
  eventmanagement_delete_reception_company = 'em-d-r-c',
  eventmanagement_delete_reception_own = 'em-d-r-o',

  eventmanagement_view_location_company = 'em-v-lc-c',
  eventmanagement_create_location_company = 'em-c-lc-c',
  eventmanagement_update_location_company = 'em-u-lc-c',
  eventmanagement_delete_location_company = 'em-d-lc-c',
  eventmanagement_delete_location_own = 'em-d-lc-o',
  eventmanagement_view_location_tab = 'em-v-lc-t',

  eventmanagement_update_settings_company = 'em-u-s-c',
  eventmanagement_view_module = 'em-v-m', // View event module in schedule content

  devicemanagement_view_device_all = 'dm-v-d-a',
  devicemanagement_create_device_all = 'dm-c-d-a',
  devicemanagement_update_device_all = 'dm-u-d-a',
  devicemanagement_delete_device_all = 'dm-d-d-a',
  devicemanagement_activate_device_all = 'dm-a-d-a',
  devicemanagement_view_device_company = 'dm-v-d-c',
  devicemanagement_create_device_company = 'dm-c-d-c',
  devicemanagement_update_device_company = 'dm-u-d-c',
  devicemanagement_delete_device_company = 'dm-d-d-c',
  devicemanagement_activate_device_company = 'dm-a-d-c',
  devicemanagement_view_device_own = 'dm-v-d-o',
  devicemanagement_create_device_own = 'dm-c-d-o',
  devicemanagement_update_device_own = 'dm-u-d-o',
  devicemanagement_delete_device_own = 'dm-d-d-o',
  devicemanagement_activate_device_own = 'dm-a-d-o',
  devicemanagement_reboot_device_company = 'dm-rb-d-c',
  devicemanagement_reboot_device_all = 'dm-rb-d-a',
  devicemanagement_print_on_device_company = 'dm-p-fs-c',
  devicemanagement_export_device_log_company = 'dm-ex-dl-c',

  devicemanagement_view_variable_all = 'dm-v-v-a',
  devicemanagement_view_variable_company = 'dm-v-v-c',
  devicemanagement_view_variable_own = 'dm-v-v-o',
  devicemanagement_update_variable_all = 'dm-u-v-a',
  devicemanagement_update_variable_company = 'dm-u-v-c',
  devicemanagement_update_variable_own = 'dm-u-v-o',

  devicemanagement_view_group_all = 'dm-v-g-a',
  devicemanagement_create_group_all = 'dm-c-g-a',
  devicemanagement_update_group_all = 'dm-u-g-a',
  devicemanagement_delete_group_all = 'dm-d-g-a',
  devicemanagement_view_group_company = 'dm-v-g-c',
  devicemanagement_create_group_company = 'dm-c-g-c',
  devicemanagement_update_group_company = 'dm-u-g-c',
  devicemanagement_delete_group_company = 'dm-d-g-c',
  devicemanagement_view_group_own = 'dm-v-g-o',
  devicemanagement_update_group_own = 'dm-u-g-o',
  devicemanagement_delete_group_own = 'dm-d-g-o',

  devicemanagement_settings_all = 'dm-d-s-a',

  devicemanagement_view_popreport_company = 'dm-v-pp-c',

  devicemanagement_view_accesscontrol_company = 'dm-v-ac-c',
  devicemanagement_manage_accesscontrol_company = 'dm-m-ac-c',

  notifications_view_setting_global = 'ns-v-s-g',
  notifications_create_setting_global = 'ns-c-s-g',
  notifications_update_setting_global = 'ns-u-s-g',
  notifications_delete_setting_global = 'ns-d-s-g',
  notifications_view_setting_company = 'ns-v-s-c',
  notifications_create_setting_company = 'ns-c-s-c',
  notifications_update_setting_company = 'ns-u-s-c',
  notifications_delete_setting_company = 'ns-d-s-c',

  projectmanagement_view_projects_all = 'pm-v-sf-a',
  projectmanagement_view_projects_company = 'pm-v-sf-c',
  projectmanagement_view_projects_own = 'pm-v-sf-o',
  projectmanagement_create_projects_all = 'pm-c-sf-a',
  projectmanagement_create_projects_company = 'pm-c-sf-c',
  projectmanagement_create_projects_own = 'projectmanagement-create-projects-own',
  projectmanagement_delete_projects_all = 'pm-d-sf-a',
  projectmanagement_delete_projects_company = 'pm-d-sf-c',
  projectmanagement_delete_projects_own = 'pm-d-sf-o',
  projectmanagement_update_projects_all = 'pm-u-sf-a',
  projectmanagement_update_projects_company = 'pm-u-sf-c',
  projectmanagement_update_projects_own = 'pm-u-sf-o',
  projectmanagement_publish_projects_all = 'pm-p-sf-a',
  projectmanagement_publish_projects_company = 'pm-p-sf-c',
  projectmanagement_publish_projects_own = 'pm-p-sf-o',
  contentmanagement_create_screenflow_in_workspace = 'pm-c-sf-r',
  contentmanagement_view_screenflow_in_workspace = 'pm-v-sf-r',
  contentmanagement_update_screenflow_in_workspace = 'pm-u-sf-r',
  contentmanagement_delete_screenflow_in_workspace = 'pm-d-sf-r',
  contentmanagement_publish_screenflow_in_workspace = 'pm-p-sf-r',

  contentmanagement_view_playlists_all = 'pm-v-pl-a',
  contentmanagement_view_playlists_company = 'pm-v-pl-c',
  contentmanagement_view_playlists_own = 'pm-v-pl-o',
  contentmanagement_create_playlists_all = 'pm-c-pl-a',
  contentmanagement_create_playlists_company = 'pm-c-pl-c',
  contentmanagement_delete_playlists_all = 'pm-d-pl-a',
  contentmanagement_delete_playlists_company = 'pm-d-pl-c',
  contentmanagement_delete_playlists_own = 'pm-d-pl-o',
  contentmanagement_update_playlists_all = 'pm-u-pl-a',
  contentmanagement_update_playlists_company = 'pm-u-pl-c',
  contentmanagement_update_playlists_own = 'pm-u-pl-o',
  contentmanagement_publish_playlists_all = 'pm-p-pl-a',
  contentmanagement_publish_playlists_company = 'pm-p-pl-c',
  contentmanagement_publish_playlists_own = 'pm-p-pl-o',
  contentmanagement_create_playlists_in_workspace = 'pm-c-pl-r',
  contentmanagement_view_playlist_in_workspace = 'pm-v-pl-r',
  contentmanagement_update_playlists_in_workspace = 'pm-u-pl-r',
  contentmanagement_delete_playlists_in_workspace = 'pm-d-pl-r',
  contentmanagement_publish_playlists_in_workspace = 'pm-p-pl-r',

  contentmanagement_view_showboards_all = 'pm-v-sb-a',
  contentmanagement_view_showboards_company = 'pm-v-sb-c',
  contentmanagement_view_showboards_own = 'pm-v-sb-o',
  contentmanagement_create_showboards_all = 'pm-c-sb-a',
  contentmanagement_create_showboards_company = 'pm-c-sb-c',
  contentmanagement_delete_showboards_all = 'pm-d-sb-a',
  contentmanagement_delete_showboards_company = 'pm-d-sb-c',
  contentmanagement_delete_showboards_own = 'pm-d-sb-o',
  contentmanagement_update_showboards_all = 'pm-u-sb-a',
  contentmanagement_update_showboards_company = 'pm-u-sb-c',
  contentmanagement_update_showboards_own = 'pm-u-sb-o',
  contentmanagement_publish_showboards_all = 'pm-p-sb-a',
  contentmanagement_publish_showboards_company = 'pm-p-sb-c',
  contentmanagement_publish_showboards_own = 'pm-p-sb-o',
  contentmanagement_create_showboards_in_workspace = 'pm-c-sb-r',
  contentmanagement_view_showboards_in_workspace = 'pm-v-sb-r',
  contentmanagement_update_showboards_in_workspace = 'pm-u-sb-r',
  contentmanagement_delete_showboards_in_workspace = 'pm-d-sb-r',
  contentmanagement_publish_showboards_in_workspace = 'pm-p-sb-r',

  schedulemanagement_view_schedules_company = 'schm-v-sch-c',
  schedulemanagement_create_schedules_company = 'schm-c-sch-c',
  schedulemanagement_update_schedules_company = 'schm-u-sch-c',
  schedulemanagement_delete_schedules_company = 'schm-d-sch-c',
  schedulemanagement_publish_schedules_company = 'schm-p-sch-c',
  schedulemanagement_view_schedules_own = 'schm-v-sch-o',
  schedulemanagement_publish_schedules_own = 'schm-p-sch-o',
  schedulemanagement_update_schedules_own = 'schm-u-sch-o',
  schedulemanagement_delete_schedules_own = 'schm-d-sch-o',

  schedulemanagement_create_emergency_company = 'schm-c-em-c',
  schedulemanagement_update_emergency_company = 'schm-u-em-c',
  schedulemanagement_view_emergency_company = 'schm-v-em-c',
  schedulemanagement_delete_emergency_company = 'schm-d-em-c',
  schedulemanagement_play_emergency_company = 'schm-p-em-c',

  filestorage_manage_files_restricted = 'fs-m-f-r',
  filestorage_view_files_all = 'fs-v-f-a',
  filestorage_create_files_all = 'fs-o-f-a',
  filestorage_update_files_all = 'fs-u-f-a',
  filestorage_delete_files_all = 'fs-d-f-a',
  filestorage_upload_files_all = 'fs-l-f-a',
  filestorage_view_files_company = 'fs-v-f-c',
  filestorage_create_files_company = 'fs-c-f-c',
  filestorage_update_files_company = 'fs-u-f-c',
  filestorage_delete_files_company = 'fs-d-f-c',
  filestorage_upload_files_company = 'fs-l-f-c',
  filestorage_view_files_own = 'fs-v-f-o',
  filestorage_create_files_own = 'fs-c-f-o',
  filestorage_update_files_own = 'fs-u-f-o',
  filestorage_delete_files_own = 'fs-d-f-o',
  filestorage_upload_files_own = 'fs-l-f-o',
  filestorage_view_gallery_company = 'fs-v-g-c',

  filestorage_create_externalfolder_company = 'fs-c-ef-c',
  filestorage_update_externalfolder_own = 'fs-u-ef-o',
  filestorage_delete_externalfolder_own = 'fs-d-ef-o',
  filestorage_view_externalfolder_company = 'fs-v-ef-c',
  filestorage_update_externalfolder_company = 'fs-u-ef-c',
  filestorage_delete_externalfolder_company = 'fs-d-ef-c',

  ordermanagement_view_stations_all = 'om-v-st-a',
  ordermanagement_view_stations_company = 'om-v-st-c',
  ordermanagement_view_stations_own = 'om-v-st-o',
  ordermanagement_create_stations_all = 'om-c-st-a',
  ordermanagement_create_stations_company = 'om-c-st-c',
  ordermanagement_delete_stations_all = 'om-d-st-a',
  ordermanagement_delete_stations_company = 'om-d-st-c',
  ordermanagement_delete_stations_own = 'om-d-st-o',
  ordermanagement_update_stations_all = 'om-u-st-a',
  ordermanagement_update_stations_company = 'om-u-st-c',
  ordermanagement_update_stations_own = 'om-u-st-o',
  ordermanagement_view_location_company = 'om-v-lc-c',
  ordermanagement_create_location_company = 'om-c-lc-c',
  ordermanagement_update_location_company = 'om-u-lc-c',
  ordermanagement_delete_location_company = 'om-d-lc-c',

  wayfinding_view_maps_company = 'wf-v-m-c',
  wayfinding_create_maps_company = 'wf-c-m-c',
  wayfinding_delete_maps_company = 'wf-d-m-c',
  wayfinding_update_maps_company = 'wf-u-m-c',
  wayfinding_update_maps_own = 'wf-u-m-o',

  booking_view_bookings_tab = 'rs-v-ov-t',
  booking_view_bookings_company = 'rs-v-bk-c',
  booking_update_bookings_company = 'rs-u-bk-c',
  booking_create_bookings_company = 'rs-c-bk-c',
  booking_delete_bookings_company = 'rs-d-bk-c',
  booking_view_rooms_tab = 'rs-v-r-t',
  booking_view_rooms_company = 'rs-v-rm-c',
  booking_create_rooms_company = 'rs-c-rm-c',
  booking_update_rooms_company = 'rs-u-rm-c',
  booking_update_settings = 'rs-u-s-c',
  booking_view_locations_tab = 'rs-v-lc-t',

  parking_view_free_spaces_tab = 'p-v-fs-t',
  parking_view_bookings_tab = 'p-v-bk-t',
  parking_view_my_bookings_tab = 'p-v-mbk-t',
  parking_view_logs_tab = 'p-v-al-t',
  parking_view_settings_tab = 'p-v-s-t',
  parking_update_settings = 'p-u-s-c',
  parking_view_bookings_company = 'p-v-bk-c',
  parking_view_bookings_own = 'p-v-bk-o',
  parking_create_bookings_company = 'p-c-bk-c',
  parking_create_bookings_own = 'p-c-bk-o',
  parking_create_bookings_restricted = 'p-c-bk-r',
  parking_update_bookings_company = 'p-u-bk-c',
  parking_update_bookings_own = 'p-u-bk-o',
  parking_update_bookings_restricted = 'p-u-bk-r',
  parking_view_logs_company = 'p-v-al-c',
  parking_view_logs_own = 'p-v-al-o',
  parking_update_licenseplates_company = 'p-u-lp-c',
  parking_update_licenseplates_own = 'p-u-lp-o',

  inventory_view_inventory_company = 'inv-v-i-c',
  inventory_create_inventory_company = 'inv-c-i-c',
  inventory_update_inventory_company = 'inv-u-i-c',
  inventory_delete_inventory_company = 'inv-d-i-c',
  inventory_import_inventory_company = 'inv-im-i-c',
  inventory_return_inventory_company = 'inv-ret-i-c',
  inventory_rate_inventory_company = 'inv-rt-i-c',
  inventory_view_logs_company = 'inv-v-il-c',
  inventory_export_logs_company = 'inv-ex-il-c',
  inventory_view_dashboard_tab = 'inv-v-db-t',

  formmanagement_view_template_company = 'fm-v-f-c',
  formmanagement_create_template_company = 'fm-c-f-c',
  formmanagement_update_template_company = 'fm-u-f-c',
  formmanagement_delete_template_company = 'fm-d-f-c',
  formmanagement_publish_template_company = 'fm-p-f-c',

  // locations & resources
  usermanagement_create_location_company = 'um-c-lc-c',
  usermanagement_view_location_company = 'um-v-lc-c',
  usermanagement_update_location_company = 'um-u-lc-c',
  usermanagement_delete_location_company = 'um-d-lc-c',
  usermanagement_create_resource_company = 'um-c-res-c',
  usermanagement_view_resource_company = 'um-v-res-c',
  usermanagement_update_resource_company = 'um-u-res-c',
  usermanagement_delete_resource_company = 'um-d-res-c'
}

export interface IAuthorizationToken {
  user_id: string;
  exp: number;
  family_name: string;
  given_name: string;
  iat: number;
  nbf: number;
  permission: UserPermissions[];
  unique_name: string;
  company_id: string;
  module: string[];
}

export interface IAuthUser {
  companyCurrency: Currency;
  companyTimeZone: string;
  companyParentId: string | null;
  id: string;
  email: string;
  phoneNumber?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  companyId: string;
  externalId?: string;
  external: boolean;
  language: string;
  permissions: UserPermissions[];
  modules: string[];
  roles: string[];
  consentFileId?: string;
  consentFileUrl?: string;
  preferences?: string;
  locations: UserInfoLocation[];
  mfaEmailEnabled: boolean;
  mfaEmailRequired: boolean;
}

export interface IToken {
  token_type: string;
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in: number;
  id_token?: string;
}
